import { render } from "./modalidades.vue?vue&type=template&id=4fbf2e6a&scoped=true"
import script from "./modalidades.vue?vue&type=script&lang=js"
export * from "./modalidades.vue?vue&type=script&lang=js"

import "./modalidades.vue?vue&type=style&index=0&id=4fbf2e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbf2e6a"]])

export default __exports__